function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.597 24H31.403A6.402 6.402 0 0 0 25 30.407V84.75a6.402 6.402 0 0 0 6.403 6.408h6.385v9.628c0 2.494 2.717 4.035 4.846 2.754l20.783-12.4h35.18A6.402 6.402 0 0 0 105 84.733V30.407c0-3.532-2.873-6.407-6.403-6.407z",
  fill: "#FFB511"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65 69.363c2.761 0 5 2.158 5 4.819C70 76.842 67.761 79 65 79s-5-2.157-5-4.818c0-2.661 2.239-4.819 5-4.819zM65 34c2.762 0 5 2.157 5 4.818V61.31c0 2.591-2.122 4.72-4.783 4.83l-.217.005c-2.762 0-5-2.157-5-4.818V38.818c0-2.59 2.119-4.701 4.777-4.813L65 34z",
  fill: "#F7F5F0"
}));
function SvgIllusBdpWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 104,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusBdpWarning);
export default __webpack_public_path__ + "static/media/IllusBDPWarning.de2c3874.svg";
export { ForwardRef as ReactComponent };